<template>
    <dialog-fullscreen :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title>Создание источника данных</template>
		<template v-slot:action>
			<v-btn
				text
				:disabled = '!validStatplace'
				:loading = 'indicator'
				color='green darken-2'
				@click = 'createStatplace'
			>
                Создать
            </v-btn>
		</template>
        <template v-slot:content>
			<v-form v-model = 'validStatplace' style = 'min-width: 320px; max-width: 800px;' ref="statForm">

                <v-autocomplete
                    :items = '$store.state.sourceTypes'
                    item-text = 'source_type_provider'
                    label = 'Провайдер'
                    v-model = "selectedTypeProvider"
                    item-value="source_type_provider"
                    :rules = "[rules.required]"
                    @change = 'selectTypeProvider'
                    single-line
                ></v-autocomplete>

                <v-autocomplete
                    :items = 'sourceTypesByProvider'
                    item-text = 'source_type_name'
                    label = 'Источник'
                    v-model = "selectedType"
                    return-object
                    :rules = "[rules.required]"
                    @change = 'fillStatplaceDefaults'
                    single-line
                ></v-autocomplete>



                <v-text-field v-model = "statplace.source_name" :rules = "[rules.required]" label = 'Отображаемое название кабинета'></v-text-field>
                <!-- Base -->
                <template v-if = 'selectedType.source_type_provider == "Funnel"'>
                    <v-text-field :rules = "[rules.required]" v-model = "statplace.source_ext.account_id" label='Идентификатор кабинета в источнике'></v-text-field>
                    <v-text-field :rules = "[rules.required]" v-model = "statplace.source_int.account_id" label='Идентификатор проекта Funnel'></v-text-field>
                    <v-text-field :rules = "[rules.required]" v-model = "statplace.source_int.source_id" label='Идентификатор кабинета в экспорте'></v-text-field>
                </template>
                <template v-if = 'selectedType.source_type_provider == "JetStat"'>
                    <v-text-field v-model = "statplace.source_ext.account_id" label='Идентификатор кабинета в источнике'></v-text-field>
                    <v-text-field :rules = "[rules.required]" v-model = "statplace.source_int.account_id" label='Идентификатор отчета JetStat'></v-text-field>
                    <v-text-field :rules = "[rules.required]" v-model = "statplace.source_int.source_id" label='Идентификатор кабинета в экспорте'></v-text-field>
                </template>
                <!-- myTarget -->
                <template v-if = 'selectedType.source_type_id == "mt"'>
                    <v-autocomplete :loading='mt.list' :items='mt.resources' label='Логин myTarget' v-model="statplace.source_ext.parent" single-line :disabled = 'mt.add' @change = 'getMTResources'>
                        <template slot='append-outer'>
                            <v-btn icon small @click='mt.add = true'><v-icon>add</v-icon></v-btn>
                        </template>
                    </v-autocomplete>
                    <v-text-field v-if = 'mt.add' v-model = "statplace.source_ext.parent" label='Логин myTarget'>
                        <template slot='append-outer'>
                            <v-tooltip bottom>
                                <template v-slot:activator= '{ on }'>
                                    <v-btn
                                        text small
                                        @click = 'openAuthWindow("mt")'
                                        v-on = 'on' :disabled = '(mt.resources || []).includes(statplace.source_ext.parent)'
                                >Подключить</v-btn>
                                </template>
                                <span v-if = '(mt.resources || []).includes(statplace.source_ext.parent)'>Указанный логин уже подключен к системе</span>
                            </v-tooltip>
                        </template>
                    </v-text-field>
                    <v-text-field v-model = "mtAccountInfo.type" label='Тип пользователя' disabled :loading = 'mt.get'>
                    </v-text-field>
                    <v-text-field v-model = "mtAccountInfo.currency" label='Валюта' disabled :loading = 'mt.get'>
                    </v-text-field>
                    <v-text-field v-model = "mtAccountInfo.id" label='Идентификатор аккаунта' disabled :loading = 'mt.get'>
                    </v-text-field>
                </template>
                <!-- AppsFlyer / Adjust-->
                <template v-if = '["appsflyer", "adjust"].includes(selectedType.source_type_id)'>
                    <v-select :items='[{"text": "iOS", "value": "iOS"}, {"text": "Android", "value": "Android"}]' label='Платформа' v-model = "statplace.source_ext.platform" :rules = "[rules.required]" single-line></v-select>
                </template>
                <!-- AppsFlyer Internal-->
                <template v-if = '["appsflyer_internal"].includes(selectedType.source_type_id)'>
                    <v-text-field v-model = "statplace.source_int.app_id" label='ID приложения'></v-text-field>
                    <v-text-field v-model = "statplace.source_int.token" label='Токен доступа'></v-text-field>
                    <v-select :items='[{"text": "iOS", "value": "ios"}, {"text": "Android", "value": "android"}]' label='Платформа' v-model = "statplace.source_int.app_platform" :rules = "[rules.required]" single-line></v-select>
                    <v-select :items='[{"text": "Partners Daily", "value": "partners_by_date"}, {"text": "Geo Daily", "value": "geo_by_date"}]' label='Тип отчета' v-model = "statplace.source_int.report_type" :rules = "[rules.required]" single-line></v-select>
                    <v-select :items='[{"text": "Europe / Moscow", "value": "Europe%2fMoscow"}, {"text": "America / Mexico City", "value": "America%2fMexico_City"}, {"text": "UTC", "value": "UTC"}]' label='Часовой пояс' v-model = "statplace.source_int.timezone" :rules = "[rules.required]" single-line></v-select>
                </template>
                <!-- Callkeeper -->
                <template v-if='selectedType.source_type_id == "callkeeper"'>
                    <v-text-field :rules = "[rules.required]" v-model = "statplace.source_ext.account_id" label = 'Логин кабинета'>
                    </v-text-field>
                    <v-text-field :rules = "[rules.required]" v-model = 'statplace.source_int.token' label = 'API-ключ из ЛК' @input = 'fillCredentials'></v-text-field>
                </template>
                <!-- Calltouch -->
                <template v-if='selectedType.source_type_id == "calltouch"'>
                    <v-text-field :disabled = 'touch.success' :success = 'touch.success' :rules = "[rules.required]" v-model = 'statplace.source_int.token' label = 'API-ключ из ЛК'></v-text-field>
                    <v-text-field :disabled = 'touch.success' :success = 'touch.success' :rules = "[rules.required]" v-model = 'statplace.source_ext.site_id' label = 'Идентификатор сайта' @input = 'fillCredentials'></v-text-field>
                    <v-btn :disabled = 'touch.success' depressed small block @click = 'touchGrants' :loading = 'touch.progress'>
                        <v-icon left>offline_bolt</v-icon><span>Проверить доступ</span>
                    </v-btn>
                </template>
                <!-- Comagic -->
                <template v-if = 'selectedType.source_type_id == "comagic"'>
                    <v-select
                        :disabled = 'touch.success'
                        :items = "[{'text': 'Ключ доступа', 'value': 'token'}, {'text': 'Логин/Пароль', 'value': 'password'}]"
                        label = 'Вариант доступа' item-text = 'text' item-value = 'value'
                        v-model = "statplace.source_int.auth_flow"
                        :rules = "[rules.required]" single-line
                    ></v-select>
                    <v-text-field
                        :disabled = 'touch.success'
                        :success = 'touch.success'
                        :rules = "[rules.required]"
                        v-model = 'statplace.source_int.login'
                        :label = 'statplace.source_int.auth_flow == "password"?"Логин в системе":"Название ключа"'
                        :error = 'touch.error.status'
                    ></v-text-field>
                    <v-text-field
                        :disabled = 'touch.success'
                        :success = 'touch.success'
                        :rules = "[rules.required]"
                        v-model = 'statplace.source_int.token'
                        :error = 'touch.error.status'
                        :error-messages = 'touch.error.messages'
                        @keyup = 'touch.error.status=false;touch.error.messages=[];'
                        :label = 'statplace.source_int.auth_flow == "password"? "Пароль в системе":"API-ключ"'
                    ></v-text-field>
                    <v-btn :disabled = 'touch.success' depressed small block @click = 'touchGrants' :loading = 'touch.progress'>
                        <v-icon left>offline_bolt</v-icon><span>Проверить доступ</span>
                    </v-btn>
                    <v-select
                        :items = 'touch.results.sites'
                        item-text = 'domain_name'
                        item-value='id'
                        v-if = 'touch.success'
                        :rules = "[rules.required]"
                        v-model = 'statplace.source_ext.site_id'
                        label = 'Идентификатор сайта'
                        @change = 'fillCredentials'
                    ></v-select>
                    <v-checkbox
                        v-model="statplace.source_int.custom"
                        label="Кастомные поля"
                        v-if='touch.success && statplace.source_ext.site_id'
                    ></v-checkbox>
                    <v-textarea
                        v-if="statplace.source_int.custom"
                        v-model="statplace.source_int.custom_fields"
                        label="Кастомные поля"
                        rows="15"
                        style="width: 500px;"
                    >
                        <v-tooltip
                            :open-on-hover="true"
                            top
                            slot="append-outer"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <label style="color: red; font-weight: bold" v-bind="attrs" v-on="on"><span><v-icon>info</v-icon></span></label>
                            </template>
                            <div>
                                Названия полей нужно вводить только через запятую (без других знаков) <br>
                                как в документации в секции <b>Параметры ответа</b><br>
                                <a href="https://www.comagic.ru/support/api/data-api/report/get_calls_report/">Ссылка на документацию</a>
                            </div>
                        </v-tooltip>
                        <template v-slot:activator="{ on, attrs }">
                            <label v-bind="attrs" v-on="on"><span><v-icon>mdi_plus</v-icon></span></label>
                        </template>
                    </v-textarea>
                </template>
                <!-- DBM -->
                <template v-if = 'selectedType.source_type_id == "doubleclick_bidmanager_api"'>
                    <v-text-field :rules = "[rules.required]" v-model = 'statplace.source_ext.publisher_id' label='Publisher ID'></v-text-field>
                    <v-text-field :rules = "[rules.required]" v-model = 'statplace.source_ext.advertiser_id' label='Advertiser ID' @input = 'fillCredentials'></v-text-field>
                </template>
                <!-- Google Analytics -->
                <template v-if = 'selectedType.source_type_id == "ga"'>
                    <v-autocomplete
                        :loading = 'ga.list'
                        :items = 'ga.accounts'
                        label='Аккаунт GA'
                        v-model = "statplace.source_ext.parent"
                        single-line
                        @change = 'getGAResources'
                    >
                        <template slot='append-outer'>
                            <v-btn small icon @click='openAuthWindow("ga")'><v-icon>add</v-icon></v-btn>
                        </template>
                    </v-autocomplete>
                    <v-autocomplete
                        :disabled = '!statplace.source_ext.parent'
                        :loading = 'ga.get'
                        return-object :items = 'ga.resources'
                        item-text='name2'
                        v-model = 'ga.selection.account' label = 'Аккаунт'
                    ></v-autocomplete>
                    <v-autocomplete
                        :loading = 'ga.get'
                        return-object
                        :items = 'ga.selection.account && ga.selection.account.webProperties'
                        :disabled = '!ga.selection || !ga.selection.account || !Object.keys(ga.selection.account).length'
                        item-text = 'name' v-model = 'ga.selection.resource' label = 'Ресурс'
                    ></v-autocomplete>
                    <v-autocomplete
                        :loading = 'ga.get'
                        :disabled = '!ga.selection || !ga.selection.resource || !Object.keys(ga.selection.resource).length'
                        :items = 'ga.selection.resource && ga.selection.resource.profiles'
                        item-text = 'name' item-value = 'id'
                        v-model = 'ga.selection.profile' label = 'Представление'
                        @change = 'fillCredentials'
                    ></v-autocomplete>
                    <v-text-field
                        :disabled = '!ga.selection || !ga.selection.profile || !Object.keys(ga.selection.profile).length'
                        v-model = "statplace.source_int.filter"
                        label='Фильтрация данных'>
                    </v-text-field>

                    <v-textarea
                            label="Показатели"
                            v-model="statplace.meta.route_metrics"
                    ></v-textarea>

                    <v-textarea
                            label="Параметры"
                            v-model="statplace.meta.route_dimensions"
                    ></v-textarea>

                    <v-checkbox
                        v-model="statplace.source_int.gac"
                        :disabled="!statplace.meta.route_metrics || !statplace.meta.route_dimensions"
                        label="Только gac"
                    >

                    </v-checkbox>

                </template>

                <!-- Google Analytics Data API GA4 -->
                <template v-if = 'selectedType.source_type_id == "ga4"'>
                    <v-autocomplete
                        :loading = 'ga4.list'
                        :items = 'ga4.accounts'
                        label='Аккаунт GA'
                        v-model = "statplace.source_ext.parent"
                        single-line
                        :rules = "[rules.required]"
                        @change = 'getGA4Resources'
                    >
<!--                        <template slot='append-outer'>-->
<!--                            <v-btn small icon @click='openAuthWindow("ga")'><v-icon>add</v-icon></v-btn>-->
<!--                        </template>-->
                    </v-autocomplete>
                    <v-autocomplete
                        :disabled = '!statplace.source_ext.parent'
                        :loading = 'ga4.get'
                        return-object
                        :items = 'ga4.resources'
                        item-text='display_name'
                        :rules = "[rules.required]"
                        v-model = 'ga4.selection.account' label = 'Аккаунт'
                    ></v-autocomplete>
                    <v-autocomplete
                        :loading = 'ga4.get'
                        return-object
                        :rules = "[rules.required]"
                        :items = 'ga4.selection.account && ga4.selection.account.properties'
                        :disabled = '!ga4.selection || !ga4.selection.account || !Object.keys(ga4.selection.account).length'
                        item-text = 'display_name' v-model = 'ga4.selection.property' label = 'Ресурс'
                        clearable
                        @change="fillCredentials"
                    ></v-autocomplete>
                    <v-autocomplete
                        :loading = 'ga4.metadata_list'
                        :items = 'ga4.selection.property && ga4.metadata.metrics'
                        :disabled = '!ga4.metadata.metrics || !ga4.selection.property || !Object.keys(ga4.selection.property).length'
                        item-text = 'text'
                        item-value="value"
                        v-model='statplace.source_int.metrics'
                        label = 'Показатели'
                        :rules = "[rules.requiredArray]"
                        multiple
                        clearable
                    ></v-autocomplete>

                    <v-autocomplete
                        :loading = 'ga4.metadata_list'
                        :items = 'ga4.selection.property && ga4.metadata.dimensions'
                        :disabled = '!ga4.metadata.dimensions || !ga4.selection.property || !Object.keys(ga4.selection.property).length'
                        item-text = 'text'
                        item-value="value"
                        v-model='statplace.source_int.dimensions'
                        label = 'Параметры'
                        :rules = "[rules.requiredArray]"
                        multiple
                        clearable
                    ></v-autocomplete>
                </template>
                <!-- Google Analytics Data API GA4 -->


                <!-- Google Adwords -->

                <template v-if="selectedType.source_type_id == 'gads'">
                    <v-autocomplete
                            :loading = 'gads.list'
                            :items = 'gads.accounts'
                            label='Аккаунт Adwords'
                            v-model = "statplace.source_ext.parent"
                            single-line
                            :rules = "[rules.required]"
                            @change = 'getGAdsResources("mcc")'
                    >
                        <template slot='append-outer'>
                            <v-btn small icon @click='openAuthWindow("gads")'><v-icon>add</v-icon></v-btn>
                        </template>

                    </v-autocomplete>
                    <v-autocomplete
                            :disabled = '!statplace.source_ext.parent'
                            :loading = 'gads.get'
                            return-object :items = 'gads.resources'
                            item-text='name'
                            v-model = 'gads.selection.account' label = 'Аккаунт'
                            :rules = "[rules.required]"
                            @change = 'getGAdsResources("client")'
                    ></v-autocomplete>
                    <v-autocomplete
                            :disabled = '!gads.selection.account'
                            :loading = 'gads.get'
                            return-object :items = 'gads.clients'
                            item-text='name'
                            v-model = 'gads.selection.client' label = 'Клиент'
                            :rules = "[rules.required]"
                            @change = 'fillCredentials'
                    ></v-autocomplete>
                </template>

                <!-- Tiktok-->
                <template v-if='selectedType.source_type_id == "tiktok_internal"'>
                    <v-autocomplete
                        :loading="tiktok.list"
                        :items="tiktok.accounts"
                        label="Аккаунт Tiktok"
                        v-model="statplace.source_ext.parent"
                        single-line
                        @change="getTiktokResources"
                    >
                        <template slot='append-outer'>
                            <v-btn small icon @click="openAuthWindow('tiktok')"><v-icon>add</v-icon></v-btn>
                        </template>

                    </v-autocomplete>

                    <v-select
                            :disabled = '!statplace.source_ext.parent'
                            :items='tiktok.currencies'
                            item-value="value"
                            item-text="name"
                            label='Валюта'
                            v-model="statplace.source_ext.currency"
                            :rules = "[rules.required]" single-line
                    >

                    </v-select>
                    <v-autocomplete
                            :disabled = '!statplace.source_ext.currency'
                            :loading = 'tiktok.get'
                            return-object :items = 'tiktok.resources'
                            item-text='name'
                            v-model = 'tiktok.selection.account' label = 'Аккаунт'
                            @change="fillCredentials"
                    ></v-autocomplete>
                </template>

                <!-- Tiktok Leads-->
                <template v-if='selectedType.source_type_id == "tiktok_leads_internal"'>
                    <v-autocomplete
                        :loading="tiktok.list"
                        :items="tiktok.accounts"
                        label="Аккаунт Tiktok"
                        v-model="statplace.source_ext.parent"
                        single-line
                        @change="getTiktokResources"
                    >
                        <template slot='append-outer'>
                            <v-btn small icon @click="openAuthWindow('tiktok')"><v-icon>add</v-icon></v-btn>
                        </template>

                    </v-autocomplete>

                    <v-autocomplete
                        :disabled = '!statplace.source_ext.parent'
                        :loading = 'tiktok.get'
                        :rules="[rules.required]"
                        return-object :items = 'tiktok.resources'
                        item-text='name'
                        v-model = 'tiktok.selection.advertiser' label = 'Аккаунт'
                        @change="fillCredentials"
                    ></v-autocomplete>

                    <v-text-field
                        :disabled="!tiktok.selection.advertiser"
                        v-model="tiktok.selection.page_id"
                        label="Идентификатор формы"
                        :rules="[rules.required]"
                    ></v-text-field>

                    <v-text-field
                        :disabled="!tiktok.selection.page_id"
                        v-model="tiktok.selection.doc_link"
                        label="Ссылка на  Google Spreadsheat"
                        :rules="[rules.required]"
                    ></v-text-field>

                    <v-text-field
                        :disabled="!tiktok.selection.doc_link"
                        v-model="tiktok.selection.sheet_id"
                        label="Название листа"
                        :rules="[rules.required]"
                    ></v-text-field>
                </template>

                <!-- Apple Search Engine -->
                <template v-if='selectedType.source_type_id == "apple_search_internal"'>
                    <v-autocomplete
                            :loading="appleSearch.list"
                            :items="appleSearch.accounts"
                            label="Аккаунт Apple Search Engine"
                            v-model="statplace.source_ext.org_id"
                            item-text='name'
                            item-value="id"
                            single-line
                            @change="getAppleSearchResources"
                    >
                    </v-autocomplete>

                    <v-select
                            :disabled = '!appleSearch.resources.length || !statplace.source_ext.org_id'
                            :items='appleSearch.reportTypes'
                            item-value="value"
                            item-text="name"
                            label='Тип отчета'
                            v-model="statplace.source_ext.report_type"
                            :rules = "[rules.required]" single-line
                            @change="fillReportType"
                    >

                    </v-select>

                    <v-autocomplete
                            :disabled = "statplace.source_ext.report_type === 'base' || !statplace.source_ext.report_type"
                            :loading = 'appleSearch.get'
                            :items = 'appleSearch.resources'
                            item-value="id"
                            item-text='name'
                            v-model = 'statplace.source_ext.campaign_id' label = 'Кампания'
                            @change="fillCredentials"
                    ></v-autocomplete>

                </template>

                <!-- Google Sheets -->
                <template v-if = 'selectedType.source_type_id == "gsheets"'>
                    <v-text-field :rules = "[rules.required]" v-model = 'statplace.source_ext.document_id' label = 'ID файла (из ссылки)'></v-text-field>
                    <v-text-field :rules = "[rules.required, rules.url]" v-model = 'statplace.source_ext.document_url' label = 'Ссылка на файл'></v-text-field>
                </template>
                <!-- Maxposter -->
                <template v-if='selectedType.source_type_id == "maxposter"'>
                    <v-text-field
                        v-model = "statplace.source_int.login"
                        label = 'Логин кабинета'
                    ></v-text-field>
                    <v-text-field
                        :rules = "[rules.required]"
                        v-model = 'statplace.source_int.token'
                        label='API-ключ из ЛК'
                        @input = 'fillCredentials'
                    ></v-text-field>
                </template>
                <!-- Smartcallback -->
                <template v-if = 'selectedType.source_type_id == "smartcallback"'>
                    <v-text-field
                        :disabled = 'touch.success'
                        :success = 'touch.success'
                        :rules = "[rules.required]"
                        v-model = 'statplace.source_int.token'
                        label = 'Токен доступа'
                    ></v-text-field>
                    <v-text-field
                        :disabled = 'touch.success'
                        :success = 'touch.success'
                        :rules = "[rules.required]"
                        v-model = 'statplace.source_int.client_id'
                        label='Идентификатор клиента'
                    ></v-text-field>
                    <v-text-field
                        :disabled = 'touch.success'
                        :success = 'touch.success'
                        :rules = "[rules.required]"
                        v-model = 'statplace.source_int.client_token'
                        label = 'Токен клиента'
                    ></v-text-field>
                    <v-text-field
                        :disabled = 'touch.success'
                        :success = 'touch.success'
                        :rules = "[rules.required]"
                        v-model = 'statplace.source_int.signature'
                        label = 'Подпись для запросов (Signature)'
                    ></v-text-field>
                    <v-btn :disabled = 'touch.success' depressed small block @click = 'touchGrants' :loading = 'touch.progress'>
                        <v-icon left>offline_bolt</v-icon><span>Проверить доступ</span>
                    </v-btn>
                    <v-select
                        :items = 'touch.results.sites'
                        item-text = 'domain_name'
                        item-value = 'id'
                        v-if = 'touch.success'
                        :rules = "[rules.required]"
                        v-model = 'statplace.source_ext.site_id'
                        @change = 'fillCredentials'
                        label = 'Идентификатор сайта'
                    ></v-select>
                    <v-checkbox
                        v-model="statplace.source_int.custom"
                        label="Кастомные поля"
                        v-if='statplace.source_ext.site_id'
                    ></v-checkbox>
                    <v-textarea
                        v-if="statplace.source_int.custom"
                        v-model="statplace.source_int.custom_fields"
                        label="Кастомные поля"
                        rows="15"
                        style="width: 500px;"
                    >
                        <v-tooltip
                            :open-on-hover="true"
                            top
                            slot="append-outer"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <label style="color: red; font-weight: bold" v-bind="attrs" v-on="on"><span><v-icon>info</v-icon></span></label>
                            </template>
                            <div>
                                Названия полей нужно вводить только через запятую (без других знаков) <br>
                                как в документации в секции <b>Параметры ответа</b><br>
                                <a href="https://www.comagic.ru/support/api/data-api/report/get_calls_report/">Ссылка на документацию</a>
                            </div>
                        </v-tooltip>
                        <template v-slot:activator="{ on, attrs }">
                            <label v-bind="attrs" v-on="on"><span><v-icon>mdi_plus</v-icon></span></label>
                        </template>
                    </v-textarea>
                </template>
                <!-- Yandex Metrika -->
                <template v-if='["yametrika", "appmetrica"].includes(selectedType.source_type_id)'>
                    <v-autocomplete
                        :loading = 'ya.list'
                        :items = 'ya.accounts'
                        label = 'Аккунт Яндекса'
                        v-model = "statplace.source_ext.parent"
                        single-line
                        @change = 'getYCounters(selectedType.source_type_id)'
                    >
                        <template slot='append-outer'>
                            <v-icon @click='openAuthWindow("ya")'>add</v-icon>
                        </template>
                    </v-autocomplete>
                    <v-autocomplete
                        :disabled = '!statplace.source_ext.parent'
                        :loading = 'ya.get'
                        v-model = "ya.selection"
                        :items = 'ya.counters'
                        item-text = 'placeholder'
                        return-object
                        label = 'Счетчик'
                        @change = 'fillCredentials'
                      ></v-autocomplete>
                </template>
                <v-menu
                    ref="selectedDate"
                    :close-on-content-click="false"
                    :return-value.sync = "statplace.meta.date_start"
                    offset-y
                    v-model = 'selectedDate'
                >
                    <template v-slot:activator = '{ on }'>
                        <v-text-field
                            v-on = 'on'
                            v-model = 'statplace.meta.date_start'
                            readonly
                            label = 'Дата начала статистики'
                            :rules = "[rules.required]"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        :rules = "[rules.required]"
                        style = 'width: 100%;'
                        :header-color = '$store.getters.uiAccent'
                        v-model = 'statplace.meta.date_start'
                        @input = "$refs.selectedDate.save(statplace.meta.date_start)"
                        locale = 'ru-ru'
                        min = '2018-01-01'
                        first-day-of-week='1'
                    ></v-date-picker>
                </v-menu>
			</v-form>
        </template>
    </dialog-fullscreen>
</template>
<script>
    import DialogFullscreen from '@/components/elements/dialogs/Fullscreen.vue'
    import dayjs from 'dayjs'
    import uuid4 from 'uuid4'
    import 'dayjs/locale/ru'
    import { orderBy } from 'lodash-es'

    export default {
        name: 'StatplaceCreateMenu',
        props: ['postAction', 'project', 'initialState'],
        components: {'dialog-fullscreen': DialogFullscreen},
        data() {
            return {
                validStatplace: false,
                statplaces: [],
                selectedType: {},
                selectedTypeProvider: {},
                sourceTypesByProvider: [],
                visibility: this.initialState,
                statplace: {
                    source_ext: {},
                    source_int: {},
                    meta: {}
                },
                indicator: false,
                indicatorSecondary: false,
                defaultStatsDate: dayjs().subtract(3, 'month').format('YYYY-MM-DD'),
                selectedDate: false,
                touch: {
                    error: {
                status: false,
                messages: []
                    },
                    success: false,
                    results: {},
                    progress: false
                },
                tiktok: {
                    list: false,
                    get: false,
                    accounts: [],
                    resources: [],
                    credentials: {},
                    selection: {},
                    currencies: [
                        {
                            'value': 'USD',
                            'name': 'USD'
                        },
                        {
                            'value': 'RUB',
                            'name': 'RUB'
                        }
                    ]
                },
                appleSearch: {
                    list: false,
                    get: false,
                    accounts: [],
                    resources: [],
                    credentials: {},
                    selection: {},
                    reportTypes: [
                        {
                            'value': 'base',
                            'name': 'Базовая метрика',
                        },
                        {
                            'value': 'creative_sets',
                            'name': 'Creative Sets',
                        },
                        {
                            'value': 'keywords',
                            'name': 'Keywords',
                        }
                    ]
                },
                ga: {
                    list: false,
                    get: false,
                    accounts: [],
                    resources: [],
                    credentials: {},
                    selection: {}
                },
                ga4: {
                    list: false,
                    get: false,
                    metadata_list: false,
                    accounts: [
                        {
                            value: 'trying-artics-pipeline@appspot.gserviceaccount.com',
                            text: 'Сервис аккаунт my-Artics'
                        }
                    ],
                    resources: [],
                    credentials: {},
                    selection: {},
                    metadata: {
                        dimensions: [],
                        metrics: []
                    }
                },
                gads: {
                    list: false,
                    get: false,
                    accounts: [],
                    resources: [],
                    credentials: {},
                    selection: {},
                    clients: []
                },
                ya: {
                    list: false,
                    get: false,
                    credentials: {},
                    accounts: [],
                    counters: [],
                    selection: {}
                },
                mt: {
                    add: false,
                    get: false,
                    list: false,
                    credentials: {},
                    resources: []
                },
                rules: {
                    required: value => !!value || 'Обязательное поле.',
                    requiredArray: value => !!value.length || 'Обязательное поле.',
                    url: value => {
                const pattern = /(https?:\/\/[^\s]+)/g
                return pattern.test(value) || 'Нераспознанный формат ссылки'
                    }
                }
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value
                if (value) {
                    //this.getStatplaces()
                    this.fillStatplaceDefaults();
                    this.getGACredentials();
                    this.getGAdsCredentials();
                    this.getYACredentials();
                    this.getMTCredentials();
                    this.getTiktokCredentials();
                    this.getAppleSearchCredentials();

                }
            },
            visibility(value) {
                this.$emit('update:initialState', value);
            },
            selectedType(value) {
                this.statplace.source_type_id = value.source_type_id
            }
        },
        computed: {
            mtAccountInfo() {
                let info = {
                    'username': this.mt.credentials.username,
                    'id': this.mt.credentials.id,
                    'currency': this.mt.credentials.currency
                }
                switch (this.mt.credentials && this.mt.credentials.types && this.mt.credentials.types[0]) {
                    case 'read_clients':
                        info['type'] = 'Агентский аккаунт';
                        break;
                    case 'read_ads':
                        info['type'] = 'Рекламодатель';
                        break;
                    case 'read_manager_clients':
                        info['type'] = 'Менеджерский аккаунт';
                        break;
                }
                return info
            }
        },
        methods: {
            getGA4Metadata() {
                this.ga4.metadata_list = true;
                const params = {
                    'login': this.$store.getters.userLogin,
                    'property_id': this.ga4.selection.property.id,
                };
                this.$http.post(this.$store.getters.endpoint + '/db/ga4/metadata', params, {
                    headers: {...this.$store.state.restrictedHeaders, ...{'Content-Type': 'application/json;charset=UTF-8'}}
                }).then(r => {
                    let response = r.body;
                    this.ga4.metadata = response.data;
                    this.ga4.metadata_list = false;
                    console.log(response)
                }).catch(e => {
                    console.log(e)
                })
            },
            openMTWindow() {
                let oaw = window.open(this.$store.getters.authHandler + "/connect/mt?email=" + this.statplace.source_ext.parent);
                oaw.postMessage("mt_ouath2_flow_initiated", document.location.origin + "/connect/mt");
            },
            fillStatplaceDefaults() {
                this.statplace = {
                    source_type_id: this.selectedType.source_type_id,
                    source_int: {},
                    source_ext: {},
                    meta: {
                        date_start: this.defaultStatsDate
                    }
                }
                this.touch.success = false;
                this.touch.progress = false;
                console.log(this.statplace)
            },
            selectTypeProvider() {
                this.selectedType = {};
                let data = this.$store.state.sourceTypes.filter(el => {
                    return el.source_type_provider === this.selectedTypeProvider
                });
                this.sourceTypesByProvider = orderBy(data, "source_type_name", "asc");
            },
            fillReportType() {
                delete this.statplace.source_ext.campaign_id;
                this.statplace.source_name = '';
                if (this.statplace.source_ext.report_type === 'base') {
                    this.fillCredentials()
                }
            },
            fillCredentials () {
                const type = this.selectedType.source_type_id
                if (type == 'ga') {
                    this.statplace.source_name = this.project.project_name + ": " +
                (this.ga.selection.account && this.ga.selection.account.name) +
                " (" + this.ga.selection.profile + ")"
                    this.statplace.source_ext.account_id = this.ga.selection.account.id
                    this.statplace.source_ext.property_id = this.ga.selection.resource.id
                    this.statplace.source_ext.profile_id = this.ga.selection.profile
                    this.statplace.source_int.source_id = this.ga.selection.profile
                    this.statplace.source_int.parent = this.statplace.source_ext.parent
                }

                if (type == 'ga4') {
                    this.statplace.source_name = `${this.project.project_name}: ${this.ga4.selection.account && this.ga4.selection.account.display_name} (${this.ga4.selection.property.id})`
                    this.statplace.source_int.parent = this.statplace.source_ext.parent;
                    this.statplace.source_int.account_id = this.ga4.selection.account.id;
                    this.statplace.source_int.property_id = this.ga4.selection.property.id;
                    this.statplace.source_int.parent = this.statplace.source_ext.parent;

                    this.statplace.source_ext.account_id = this.ga4.selection.account.id;
                    this.statplace.source_ext.property_id = this.ga4.selection.property.id;
                    if (this.ga4.selection.property && this.ga4.selection.property.id) {
                        this.getGA4Metadata();
                    }
                }

                if (type == 'gads') {
                    this.statplace.source_name = `${this.project.project_name}: ${this.gads.selection.client.name} (${this.gads.selection.client.customerId})`
                    this.statplace.source_int.parent = this.statplace.source_ext.parent;
                    this.statplace.source_int.source_id = this.gads.selection.client.customerId;
                }
                if (type == 'yametrika' || type == 'appmetriсa') {
                    this.statplace.source_name = this.ya.selection.placeholder
                    this.statplace.source_ext.counter_id = this.ya.selection.id
                    this.statplace.source_int.source_id = this.ya.selection.id
                    this.statplace.source_int.filter = ''
                    this.statplace.source_int.parent = this.statplace.source_ext.parent
                }
                if (type == 'callkeeper' || type == 'maxposter') {
                    this.statplace.source_ext.site_id = uuid4()
                    this.statplace.source_int.source_id = this.statplace.source_ext.site_id
                }
                if (type == 'calltouch' || type == 'comagic' || type == 'smartcallback') {
                    this.statplace.source_int.source_id = this.statplace.source_ext.site_id
                }
                if (type == 'doubleclick_bidmanager_api') {
                    this.statplace.source_ext.account_id = this.statplace.source_ext.advertiser_id
                }
                if (type == 'mytarget') {
                    this.statplace.source_name = this.mtAccountInfo.username + ` (${this.mtAccountInfo.type})`
                    this.statplace.source_ext.account_id = this.mtAccountInfo.id
                    this.statplace.source_ext.currency = this.mtAccountInfo.currency
                    this.statplace.source_ext.type = this.mtAccountInfo.type
                    this.statplace.source_int.account_id = this.mtAccountInfo.id
                }
                if (type == 'mt') {
                    this.statplace.source_int.source_id = this.statplace.source_ext.parent
                }
                if (type === 'tiktok_internal') {
                    if (!this.statplace.source_name) {
                        this.statplace.source_name = this.tiktok.selection.account.name + ' (' +
                        this.tiktok.selection.account.id + ')';
                    }
                    this.statplace.source_ext.account_id = this.tiktok.selection.account.id;
                    this.statplace.source_int.account_id = this.tiktok.selection.account.id;
                    this.statplace.source_int.parent = this.statplace.source_ext.parent;
                    this.statplace.source_int.currency = this.statplace.source_ext.currency;
                }

                if (type === 'tiktok_leads_internal') {
                    // if (!this.statplace.source_name) {
                    //     this.statplace.source_name = this.tiktok.selection.advertiser.name + ' (' +
                    //         this.tiktok.selection.advertiser.id + ')';
                    // }
                    this.statplace.source_ext.advertiser_id = this.tiktok.selection.advertiser.id;
                    this.statplace.source_int.advertiser_id = this.tiktok.selection.advertiser.id;
                    this.statplace.source_int.parent = this.statplace.source_ext.parent;
                    this.statplace.source_int.page_id = this.tiktok.selection.page_id;
                    this.statplace.source_int.doc_link = this.tiktok.selection.doc_link;
                    this.statplace.source_int.sheet_id = this.tiktok.selection.sheet_id;
                }

                if (type === 'apple_search_internal') {
                    if (this.statplace.source_ext.org_id && this.statplace.source_ext.report_type) {

                        const org = this.appleSearch.accounts.find(el => {
                            return el.id === this.statplace.source_ext.org_id
                        });
                        const report_type = this.appleSearch.reportTypes.find(el => {
                            return el.value === this.statplace.source_ext.report_type
                        });

                        if (this.statplace.source_ext.report_type === 'base') {
                            this.statplace.source_name = `${org.name} (${report_type.name})`
                        } else {
                            if (this.statplace.source_ext.campaign_id) {
                                const resource = this.appleSearch.resources.find(el => {
                                    return el.id === this.statplace.source_ext.campaign_id
                                });
                                this.statplace.source_name = `${resource.clientName} (${report_type.name}) (${this.statplace.source_ext.campaign_id})`;
                            } else {
                                this.statplace.source_name = '';
                            }
                        }
                    }
                    this.statplace.source_int.campaign_id = this.statplace.source_ext.campaign_id;
                    this.statplace.source_int.report_type = this.statplace.source_ext.report_type;
                    this.statplace.source_int.org_id = this.statplace.source_ext.org_id;
                }
            },
            openAuthWindow(target) {
                let target_link = `https://123.artics.ru/connect/${target}`
                // let target_link = `http://127.0.0.1:5005/connect/${target}`
                if (target == 'mt') {
                    target_link = target_link + `?email=${this.statplace.source_ext.parent}`
                }
                let oaw = window.open(target_link)
                oaw.postMessage(`${target}_ouath2_flow_initiated`, `https://123.artics.ru/connect/${target}`)
                // oaw.postMessage(`${target}_ouath2_flow_initiated`, `http://127.0.0.1:5005/connect/${target}`)
            },
            getStatplaces() {
                this.indicatorSecondary = true;
                this.$http.get(this.$store.getters.endpoint + '/db/list', {
                    emulateJSON: true,
                    params: { 'login': this.$store.getters.userLogin, 'kind': 'statplaces' },
                    headers: this.$store.state.restrictedHeaders
                }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.statplaces = response.data;

                        function pad(number) {
                            if (number < 10) {
                                return '0' + number;
                            }
                            return number;
                        }
                        this.statplaces.map((s) => {
                            let d = new Date(s.date_start);
                            s.placeholder = s.source + ' | ' + s.ext_source_id;
                            s.date_start = d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate())
                        })
                        this.statplaces = [];
                        this.indicatorSecondary = false;
                    } else {
                        console.log(response)
                    }
                })
            },
            touchGrants() {
                this.touch.progress = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                };
                if (this.statplace.source == 'Comagic') {
                    this.statplace.api_version = 2;
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                    'statplace': this.statplace
                };
                this.$http.post(
                    // this.$store.getters.endpoint + '/db/touch_access',
                    'https://calltrackers.service.artics.ru/ct/touch_access',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                }).then((r) => {
                    let response = r.body;
                    this.touch.progress = false;
                    if (response.result) {
                        this.touch.results = response;
                        this.touch.success = true;
                    } else {
                        this.touch.error.status = true;
                        if (response.step == 'Auth') {
                            this.touch.error.messages.push('Авторизационные данные неверны или доступ к API не открыт для всех IP-адресов')
                            setTimeout(function() {
                                this.touch.error.status = false;
                                this.touch.error.messages = []
                            }, 1500);
                        }
                        console.log(response)
                    }
                })
            },
            getYCounters(type) {
                if (!this.statplace.source_ext.parent || this.statplace.source_ext.parent.length == 0) {
                    return false
                }
                this.ya.get = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                    'email': this.statplace.source_ext.parent,
                    'type': (type == 'yametrika') ? 'metrika' : 'app'
                }
                this.$http.post(this.$store.getters.endpoint + '/db/connect_ya',
                    requestData, {
                    headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.ya.get = false;
                        this.ya.counters = response.data
                        this.ya.counters.map((c) => c.placeholder = c.name + ' (' + c.id + ')')
                    } else {
                        console.log(response)
                    }
                })
            },
            getGAResources() {
                if (!this.statplace.source_ext.parent || this.statplace.source_ext.parent.length == 0) {
                    return false
                }
                this.ga.get = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                    'email': this.statplace.source_ext.parent
                }
                this.$http.post(this.$store.getters.endpoint + '/db/connect_ga',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.ga.get = false;
                        this.ga.resources = response.data.items
                    } else {
                        console.log(response)
                    }
                })
            },
            getGA4Resources() {
                if (!this.statplace.source_ext.parent || this.statplace.source_ext.parent.length == 0) {
                    return false
                }
                this.ga4.get = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                    'email': this.statplace.source_ext.parent
                }
                this.$http.post(this.$store.getters.endpoint + '/db/connect_ga4',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.ga4.get = false;
                        this.ga4.resources = response.data
                    } else {
                        console.log(response)
                    }
                })
            },
            getGAdsResources(param) {
                if (!this.statplace.source_ext.parent || this.statplace.source_ext.parent.length == 0) {
                    return false
                }
                this.gads.get = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                };

                let requestData = {
                    'login': this.$store.getters.userLogin,
                    'email': this.statplace.source_ext.parent,
                    'param': param
                }
                if (param === 'client') {
                    requestData = {
                        ...requestData,
                        customer_id: this.gads.selection.account.customer_id
                    }
                    delete this.gads.selection.client;
                }
                this.$http.post(this.$store.getters.endpoint + '/db/connect_gads',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.gads.get = false;
                        if (param === 'client') {
                            this.gads.clients = response.data
                        } else {
                            this.gads.resources = response.data
                        }

                    } else {
                        console.log(response)
                    }
                })
            },
            getTiktokResources() {
                if (!this.statplace.source_ext.parent || this.statplace.source_ext.parent.length == 0) {
                    return false
                }
                this.tiktok.get = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                    'email': this.statplace.source_ext.parent
                }
                this.$http.post(this.$store.getters.endpoint + '/db/connect_tiktok',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.tiktok.get = false;
                        this.tiktok.resources = response.data.list;
                    } else {
                        console.log(response)
                    }
                })
            },
            getAppleSearchResources() {
                if (!this.statplace.source_ext.org_id || this.statplace.source_ext.org_id.length == 0) {
                    return false
                }
                this.appleSearch.get = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                };
                let requestData = {
                    'login': this.$store.getters.userLogin,
                    'org_id': this.statplace.source_ext.org_id
                };
                this.$http.post(this.$store.getters.endpoint + '/db/connect_apple_search',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.appleSearch.get = false;
                        this.appleSearch.resources = response.list;
                        if (this.statplace.source_name) {
                            this.statplace.source_name = '';
                        }
                    } else {
                        console.log(response)
                    }
                })
            },
            getMTResources() {
                if (!this.statplace.source_ext.parent || this.statplace.source_ext.parent == 0) {
                    return false
                }
                this.mt.get = true;
                let requestData = {
                    'login': this.$store.getters.userLogin,
                    'mail': this.statplace.source_ext.parent
                }
                this.$http.post(this.$store.getters.endpoint + '/db/connect_mt',
                    requestData, {
                        headers: this.$store.state.restrictedHeaders
                }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.mt.get = false;
                        this.mt.credentials = response.data;
                        this.fillCredentials()
                    } else {
                        console.log(response)
                    }
                })
            },
            getGACredentials() {
                this.ga.list = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    'login': this.$store.getters.userLogin
                }
                this.$http.put(this.$store.getters.endpoint + '/db/connect_ga',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.ga.list = false;
                        this.ga.accounts = response.list
                        this.ga4.accounts = response.list;
                    } else {
                        console.log(response)
                    }
                })
            },
            getGAdsCredentials() {
                this.gads.list = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    'login': this.$store.getters.userLogin
                }
                this.$http.put(this.$store.getters.endpoint + '/db/connect_gads',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.gads.list = false;
                        this.gads.accounts = response.list
                    } else {
                        console.log(response)
                    }
                })
            },
            getTiktokCredentials() {
                this.tiktok.list = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                }
                this.$http.put(this.$store.getters.endpoint + '/db/connect_tiktok',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.tiktok.list = false;
                        this.tiktok.accounts = response.list
                    } else {
                        console.log(response)
                    }
                })
            },
            getAppleSearchCredentials() {
                this.appleSearch.list = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                }
                this.$http.put(this.$store.getters.endpoint + '/db/connect_apple_search',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.appleSearch.list = false;
                        this.appleSearch.accounts = response.list
                    } else {
                        console.log(response)
                    }
                })
            },
            getYACredentials() {
                this.ya.list = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                }
                this.$http.put(this.$store.getters.endpoint + '/db/connect_ya',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.ya.list = false;
                        this.ya.accounts = response.list
                    } else {
                        console.log(response)
                    }
                })
            },
            getMTCredentials() {
                this.mt.list = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                }
                this.$http.put(this.$store.getters.endpoint + '/db/connect_mt',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.mt.list = false;
                        this.mt.resources = response.list
                    } else {
                        console.log(response)
                    }
                })
            },
            addGACredentials() {
                this.ga.list = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                    'new_entity': this.ga.credentials
                }
                this.$http.put(this.$store.getters.endpoint + '/db/connect_ga',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.ga.list = false;
                        this.ga.accounts = response.list
                    } else {
                        console.log(response)
                    }
                })
            },
            createStatplace() {
                this.fillCredentials();
                this.indicator = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let internalSources = [
                    'Google Analytics', 'Comagic', 'Yandex.Metrika',
                    'Calltouch', 'Callkeeper', 'Smartcallback',
                    'Maxposter', 'AppMetrica'
                ];
                let requestData = {
                    login: this.$store.getters.userLogin
                };
                if (typeof this.statplace.source_ext != 'object') {
                    this.statplace.source_ext = JSON.parse(this.statplace.source_ext)
                }
                if (typeof this.statplace.source_int != 'object') {
                    this.statplace.source_int = JSON.parse(this.statplace.source_int)
                }
                if (typeof this.statplace.meta != 'object') {
                    this.statplace.meta = JSON.parse(this.statplace.meta)
                }
                this.$http.post(this.$store.getters.endpoint + '/db/project/' + this.project.project_id + '/statplaces', {
                    ...requestData,
                    ...{ 'statplace': this.statplace }
                }, {
                    headers: { ...this.$store.state.restrictedHeaders,
                ...requestHeaders
                    }
                }).then((r) => {
                    this.indicator = false;
                    this.visibility = false;
                    let response = r.body;
                    if (response.result) {
                        this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'create',
                                target: 'project_source'
                            },
                            once: false
                        })
                        this.postAction('statplaces');
                    } else {
                        this.errorCreate = true;
                        this.errorCreateMessage = ['Идентификатор уже используется в другом объекте']
                        console.log(response)
                    }
                }, (r) => {
                    this.indicator = false;
                    let error = r.body;
                    console.log(error)
                });
            }
        },
        mounted() {
            window.addEventListener('message', (event) => {
                if (event.data.event == 'ga_oauth_complete') {
                    this.ga.credentials = {
                        'email': event.data.email,
                        'credentials': event.data.credentials
                    }
                    this.ga.accounts.push(event.data.email)
                }
                if (event.data.event == 'ya_oauth_complete') {
                    this.ya.credentials = {
                        'email': event.data.email,
                        'credentials': event.data.credentials
                    }
                    this.ya.accounts.push(event.data.email)
                }
                if (event.data.event == 'mt_oauth_complete') {
                    console.log(event)
                    this.mt.credentials = {
                        'email': event.data.email,
                        'credentials': event.data.credentials
                    }
                    this.statplace.parent = event.data.email;
                    this.getMTResources()
                    this.mt.resources.push(event.data.email)
                    this.mt.add = false;
                }
            });
        }
    }
</script>
